import React from 'react';
import { useState, useEffect, useRef, useMemo } from 'react';
import { AxiosInstance } from './utils';
import NewsletterModal from './NewsLetterModal';
import Spinner from './Spinner';

interface MainWebHeaderProps {
  events?: any[];
}

const MainWebHeader: React.FC<MainWebHeaderProps> = ({ events = [] }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [archiveOpen, setArchiveOpen] = useState(false);
  const [archiveEvents, setArchiveEvents] = useState<any[]>([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const archiveRef = useRef<HTMLDivElement>(null);
  const mobileMenuRef = useRef<HTMLDivElement>(null);
  const [newsletterOpen, setNewsletterOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleDropdown = (e: React.MouseEvent) => {
    e.preventDefault();
    setDropdownOpen(!dropdownOpen);
  };

  const toggleArchive = (e: React.MouseEvent) => {
    e.preventDefault();
    setArchiveOpen(!archiveOpen);
  };

  useEffect(() => {
    const fetchArchiveEvents = async () => {
      try {
        const response = await AxiosInstance.get('/api/getevent?eventstatus=CLOSED');
        if (response.data.result === 'Success') {
          if (response.data.data.length === 0) {
            setArchiveEvents([{ name: 'NO ARCHIVAL', eventcode: '' }]);
          } else {
            setArchiveEvents(response.data.data);
          }
        }
      } catch (error) {
        console.error('Error fetching archive events:', error);
      }
    };
    fetchArchiveEvents();
  }, []);

  const latestEvents = useMemo(() => {
    const sorted = [...events].sort((a, b) => new Date(b.startdate).getTime() - new Date(a.startdate).getTime());
    return sorted.slice(0, 2);
  }, [events]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchArchiveEvents = async () => {
      setIsLoading(true);
      try {
        const response = await AxiosInstance.get('/api/getevent?eventstatus=CLOSED');
        if (response.data.result === 'Success') {
          if (response.data.data.length === 0) {
            setArchiveEvents([{ name: 'NO ARCHIVAL', eventcode: '' }]);
          } else {
            setArchiveEvents(response.data.data);
          }
        }
      } catch (error) {
        console.error('Error fetching archive events:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchArchiveEvents();
  }, []);
 const openNewsletter = () => {
            setNewsletterOpen(true);
         };
         
         const closeNewsletter = () => {
            setNewsletterOpen(false);
         };
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
      if (archiveRef.current && !archiveRef.current.contains(event.target as Node)) {
        setArchiveOpen(false);
      }
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target as Node)) {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const headerStyles = `
    .mainwebheader-header {
      text-transform: uppercase;
      background: white;
      box-shadow: 0 1px 6px rgb(0 0 0 / 0.1);
      padding: 0px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: sticky;
      top: 0;
      z-index: 10000000;
      width: 100%;
    }
    .mainwebheader-logo {
      font-weight: 700;
      font-size: 1.3rem;
      color: black;
      flex-shrink: 0;
    }
    .mainwebheader-nav {
      display: flex;
      gap: 20px;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: wrap;
    }
    .mainwebheader-nav a {
      font-weight: 600;
      padding: 0px 8px 0px 8px;
      border-radius: 6px;
      transition: background-color 0.2s;
    }
    .mainwebheader-nav a:hover {
      background-color: #d1fae5;
    }
    .mainwebheader-social-icons {
      display: flex;
      gap: 12px;
    }
    .mainwebheader-social-icons svg {
      width: 20px;
      height: 20px;
      fill: #64748b;
      cursor: pointer;
      transition: fill 0.3s;
    }
    .mainwebheader-social-icons svg:hover {
      fill: #059669;
    }
    .mainfixed {
      position: fixed;
    }
    
    /* Mobile menu toggle button */
    .mobile-menu-toggle {
      display: none;
      flex-direction: column;
      background: none;
      border: none;
      cursor: pointer;
      padding: 5px;
      z-index: 10000001;
    }
    .mobile-menu-toggle span {
      width: 25px;
      height: 3px;
      background-color: #333;
      margin: 3px 0;
      transition: 0.3s;
      border-radius: 2px;
    }
    
    /* Dropdown styles */
    .dropdown-menu {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 99999999;
      display: none;
      min-width: 160px;
      padding: 0.5rem 0;
      margin: 0.125rem 0 0;
      font-size: 1rem;
      color: #212529;
      text-align: left;
      list-style: none;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid rgba(0,0,0,.15);
      border-radius: 0.25rem;
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
      right: auto;
    }
    
    .dropdown-menu.show {
      display: block;
    }
    
    .dropdown-item {
      display: block;
      width: 100%;
      padding: 0.25rem 1rem;
      z-index: 99999999;
      clear: both;
      font-weight: 400;
      color: #212529;
      text-align: inherit;
      text-decoration: none;
      white-space: nowrap;
      background-color: transparent;
      border: 0;
    }
    
    .dropdown-item:hover {
      color: #1e2125;
      text-decoration: none;
      background-color: #e9ecef;
    }
    
    .dropdown-item.disabled {
      color: #6c757d;
      pointer-events: none;
      background-color: transparent;
    }
    
    /* Mobile responsive styles */
    @media (max-width: 768px) {
      .mainwebheader-header {
        padding: 0px 20px;
        text-transform: uppercase;
      }
      .mainwebheader-logo {
        font-size: 1.1rem;
        color: blue;
      }
      .mobile-menu-toggle {
        display: flex;
      }
      .mainwebheader-nav {
        flex-direction: column;
        gap: 15px;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        padding: 20px;
        display: none;
      }
      .mainwebheader-nav.show {
        display: flex;
      }
      .mainwebheader-social-icons {
        justify-content: center;
        margin-top: 15px;
        border-top: 1px solid #eee;
        padding-top: 15px;
      }
      .dropdown-menu {
        position: static;
        display: none;
        box-shadow: none;
        border: none;
        background: transparent;
        padding: 0;
        margin: 0;
      }
      .dropdown-menu.show {
        display: block;
      }
      .dropdown-item {
        padding: 10px 0;
        border-bottom: 1px solid #eee;
      }
      .dropdown-item:last-child {
        border-bottom: none;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: headerStyles }} />
      <header className="mainwebheader-header mainfixed">
        <div className="mainwebheader-logo"><a href="/"><i className="fa fa-home" aria-hidden="true"></i></a></div>
        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
          aria-expanded={mobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <nav className={`mainwebheader-nav ${mobileMenuOpen ? 'show' : ''}`} ref={mobileMenuRef}>
          
          { latestEvents.length == 0 ? <Spinner  size="xtrasmall"/> : latestEvents.map((event, index) => (
            <a key={event.eventcode} href={`/event/${event.eventcode}`} target="_blank">#{event.eventcode}</a>
          ))}
        <a href="/cfp">CFP</a>
          <a href="/blogs">Blog</a>
          <a href="/gallery">Gallery</a>
          <a href="/contact">Contact</a>
          <div className="nav-item dropdown" ref={archiveRef}>
            <a 
              className="nav-link dropdown-toggle" 
              href="#" 
              onClick={toggleArchive} 
              role="button" 
              aria-haspopup="true" 
              aria-expanded={archiveOpen}
            >
              Archive
            </a>
            <div className={`dropdown-menu ${archiveOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
              {archiveEvents.length === 0 ? <Spinner  size="xtrasmall"/> : archiveEvents.map(event => (
                event.eventcode ? (
                  <a key={event.eventcode} className="dropdown-item" href={`/event/${event.eventcode}`} target="_blank">#{event.eventcode}</a>
                ) : (
                  <span key="no-archival" className="dropdown-item disabled">{event.name}</span>
                )
              ))}
            </div>
          </div>
          
          <div className="nav-item dropdown" ref={dropdownRef}>
            <a 
              className="nav-link dropdown-toggle" 
              href="#" 
              onClick={toggleDropdown} 
              role="button" 
              aria-haspopup="true" 
              aria-expanded={dropdownOpen}
            >
              About
            </a>
            <div className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
              <a className="dropdown-item" href="/aboutus">About Us</a>
              <a className="dropdown-item" href="/teammembers">Team</a>
              <a className="dropdown-item" href="/codeofconduct">Code of Conduct</a>
            </div>
          </div>
          
          <div className="mainwebheader-social-icons" aria-label="Social Media Links">
             <a onClick={openNewsletter} title="Newsletter" aria-label="Newsletter">
              <i className="fa fa-envelope"></i>
            </a>
            <a href="https://lnkd.in/gZ8N3Kxr" title="LinkedIn" target='_about' aria-label="LinkedIn">
            <i className="fa-brands fa-linkedin"></i> </a>
            <a href="https://x.com/bsidesbangalore" title="Twitter" target='_about' aria-label="Twitter">
             <i className="fa fa-twitter"></i> </a>
            <a href="https://www.instagram.com/bsides_bangalore" title="instagram" target='_about' aria-label="instagram">
              <i className="fa-brands fa-instagram"></i>  </a>
                <a href="https://www.youtube.com/channel/UC0SqOU2NDDIP0bbt5OwW8Hw" title="youtube" target='_about' aria-label="youtube">
           <i className="fa-brands fa-youtube"></i>
          </a>
          </div>
        </nav>
      </header>
          <NewsletterModal 
      isOpen={newsletterOpen} 
      onClose={closeNewsletter} 
    />
    </>
  );
};

export default MainWebHeader;
